<template>
  <div class="raft-js-base-filters">
    <fieldset class="raft-js-base-filters-fieldset">
      <b-form>
        <raft-busy
          v-if="isBusy"
          :is-raft-styling="false"
          data-test="filters-busy"
          busy-text="Loading filters..."
        />
        <template v-else>
          <filter-row
            v-for="(rowFilterData, index) in filtersDivided"
            :cols-per-row="colsPerRow"
            :key="index"
            :filters="rowFilterData"
            @update-filters="updateFilters"
          />
        </template>
      </b-form>
    </fieldset>
  </div>
</template>

<script>
import FilterRow from "./FilterRow.vue";
import RaftBusy from "../RaftBusy.vue";

export default {
  name: "BaseFilters",
  components: { FilterRow, RaftBusy },
  data() {
    return {
      filtersDivided: [],
      filterValues: {},
    };
  },
  props: {
    filters: {
      type: Array,
      required: true,
    },
    colsPerRow: {
      type: Number,
      default: 3,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateFilters: function (filterValues) {
      Object.keys(filterValues).forEach((fieldName) => {
        this.filterValues[fieldName] = filterValues[fieldName];
      });
      this.$emit("update-filters", this.filterValues);
    },
  },
  watch: {
    filters: {
      immediate: true,
      handler(newFilters) {
        let filtersRow = [];
        const cols = this.colsPerRow;
        const filtersDivided = [];
        newFilters.forEach((filterData) => {
          if (filtersRow.length !== 0 && filtersRow.length % cols === 0) {
            filtersDivided.push(filtersRow);
            filtersRow = [];
          }
          filtersRow.push(filterData);
        });
        if (filtersRow.length) {
          filtersDivided.push(filtersRow);
        }
        this.filtersDivided = filtersDivided;
      },
    },
  },
};
</script>
<style scoped>
.raft-js-base-filters-fieldset {
  display: flex;
  justify-content: center;
}
</style>
